import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { useAuth } from "../context/AuthContext";
import api from "../api/axios";
import { jwtDecode } from "jwt-decode";
import { Toast } from "primereact/toast";
import LoginService from "../services/LoginService";

export default function LoginRegister() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const toast = useRef(null);
  const navigate = useNavigate();
  const { setToken, setUser } = useAuth();

  const [activeIndex, setActiveIndex] = useState(0);
  const [forgotVisible, setForgotVisible] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotError, setForgotError] = useState("");

  const [loginEmail, setLoginEmail] = useState("");
  const [isPhoneLogin, setIsPhoneLogin] = useState(false);
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  const [tenantName, setTenantName] = useState("");
  const [fullName, setFullName] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPhone, setRegisterPhone] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [regError, setRegError] = useState("");
  const [regSuccess, setRegSuccess] = useState("");

  const handleLogin = async () => {
    if (!loginEmail || !loginPassword) {
      setLoginError("Lütfen e-posta/telefon ve şifre alanlarını doldurunuz.");
      return;
    }
    try {
      setLoginError("");
      const response = await api.post("/auth/login", {
        email: loginEmail,
        password: loginPassword,
      });
      const token = response.data.data.token;
      localStorage.setItem("token", token);
      setToken(token);
      const decoded = jwtDecode(token);
      setUser(decoded);
      navigate("/");
    } catch (err) {
      setLoginError("E-posta veya şifre hatalı!");
    }
  };

  const handleRegister = async () => {
    if (!tenantName || !fullName || !registerEmail || !registerPhone || !registerPassword) {
      setRegError("Lütfen tüm alanları eksiksiz doldurunuz.");
      return;
    }
    try {
      setRegError("");
      const res = await LoginService.register({
        tenantName,
        fullName,
        email: registerEmail,
        userPhoneNumber: registerPhone,
        password: registerPassword,
      });
      if (res.success === false) {
        toast.current.show({ severity: "warn", summary: "Uyarı", detail: res.message || "Hata" });
        setRegError(res.message || "Kayıt hatası.");
      } else {
        toast.current.show({ severity: "success", summary: "Başarılı", detail: "Kayıt başarılı!" });
        setRegSuccess("Kayıt başarılı! Şimdi giriş yapabilirsiniz.");
        setActiveIndex(0);
      }
    } catch (err) {
      setRegError("Hata oluştu!");
    }
  };
  const [forgotLoading, setForgotLoading] = useState(false);
const handleForgotPassword = async () => {
  setForgotMessage("");

  if (!forgotEmail?.trim()) {
    setForgotMessage("Lütfen e-posta adresinizi girin.");
    return;
  }

  try {
    setForgotLoading(true); 
    const response = await api.post(`/auth/forgot-password`, {
      email: forgotEmail.trim(),
    });

    setForgotMessage(
      response.data?.message ||
        "Eğer bu e-posta ile kayıtlı bir hesap varsa şifre sıfırlama bağlantısı gönderilecektir."
    );
  } catch (error) {
    setForgotMessage(
      error?.response?.data?.message ||
        "Şifre sıfırlama talebi alınırken bir hata oluştu."
    );
  } finally {
    setForgotLoading(false);
  }
};
  return (
    <div className="login-page-container">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="login-card">
        {/* SOL PANEL */}
        <div className="brand-panel">
          <div className="brand-header">
            <div className="brand-logo-box">
              <i className="pi pi-wallet"></i>
            </div>
            <span className="brand-name">KasamBenim</span>
          </div>

          <div className="brand-content">
            <h1 className="brand-title">Ticaretin <span className="highlight">Yeni Nesil</span> Yönetim Paneli</h1>
            <p className="brand-subtitle">Stoktan finansa, satıştan raporlamaya kadar her şey tek bir noktada.</p>

            <div className="feature-list">
              {[
                { icon: "pi-cloud", title: "Bulut Tabanlı", desc: "Her yerden güvenli erişim." },
                { icon: "pi-chart-line", title: "Gelişmiş Analitik", desc: "Verilerinizi anlık izleyin." },
                { icon: "pi-box", title: "Stok Yönetimi", desc: "Ürünlerinizi takip edin." },
                { icon: "pi-shopping-cart", title: "Hızlı Satış", desc: "Saniyeler içinde fatura." }
              ].map((f, i) => (
                <div key={i} className="feature-item">
                  <div className="feature-icon">
                    <i className={`pi ${f.icon}`}></i>
                  </div>
                  <div className="feature-text">
                    <span className="feature-title">{f.title}</span>
                    <span className="feature-desc">{f.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="brand-footer">
            © 2024 KasamBenim Software
          </div>
        </div>

        {/* SAĞ PANEL */}
        <div className="form-panel">
          <div className="form-container">
            <div className="tab-switcher">
              <button onClick={() => setActiveIndex(0)} className={activeIndex === 0 ? "active" : ""}>GİRİŞ YAP</button>
              <button onClick={() => setActiveIndex(1)} className={activeIndex === 1 ? "active" : ""}>KAYIT OL</button>
            </div>

            {activeIndex === 0 ? (
              <div className="fade-in">
                <div className="form-header">
                  <h2>Tekrar Hoş Geldiniz</h2>
                  <p>Hesabınıza giriş yaparak devam edin.</p>
                </div>

                <div className="form-fields">
                  {regSuccess && <Message severity="success" text={regSuccess} style={{width:'100%'}} />}
                  {loginError && <Message severity="error" text={loginError} style={{width:'100%'}} />}

                  <div className="field-group">
                    <label>E-POSTA VEYA TELEFON</label>
                    <span className="p-input-icon-left w-full">
                      <i className="pi pi-user" style={{ left: '0.75rem', top: '65%', transform: 'translateY(-50%)', zIndex: 1 }}/>
                      {isPhoneLogin ? (
                        <InputMask
                          value={loginEmail}
                          mask="0(999) 999 99 99"
                          autoFocus
                          onChange={(e) => {
                            setLoginEmail(e.value);
                            if (!e.value || e.value.replace(/[^0-9]/g, "").length === 0) {
                              setIsPhoneLogin(false);
                            }
                          }}
                          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                          placeholder="05..."
                        />
                      ) : (
                        <InputText
                          value={loginEmail}
                          onChange={(e) => {
                            const val = e.target.value;
                            setLoginEmail(val);
                            if (/^\d/.test(val)) {
                              setIsPhoneLogin(true);
                            }
                          }}
                          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                          placeholder="E-posta veya 05..."
                        />
                      )}
                    </span>
                  </div>

                  <div className="field-group">
                    <div className="label-row">
                      <label>ŞİFRE</label>
                      <button onClick={() => setForgotVisible(true)} className="forgot-btn">Şifremi Unuttum?</button>
                    </div>
                    <span className="p-input-icon-left w-full">
                      <div className="w-full relative">
  <i className="pi pi-lock absolute" style={{ left: '0.75rem', top: '50%', transform: 'translateY(-50%)', zIndex: 1 }} />
  <Password
    value={loginPassword}
    onChange={(e) => setLoginPassword(e.target.value)}
    onKeyDown={(e) => e.key === "Enter" && handleLogin()}
    feedback={false}
    toggleMask
    className="w-full"
    inputClassName="w-full pl-5"
    placeholder="••••••••"
  />
</div>  </span>
                  </div>

                  <Button label="Giriş Yap" icon="pi pi-arrow-right" iconPos="right" onClick={handleLogin} className="submit-btn" />
                </div>
              </div>
            ) : (
              <div className="fade-in">
                <div className="form-header">
                  <h2>Hesap Oluştur</h2>
                  <p>Dijital dönüşüme bugün başlayın.</p>
                </div>

                <div className="form-fields">
                  {regError && <Message severity="error" text={regError} style={{width:'100%'}} />}

                  <div className="field-group">
                    <label>İŞLETME ADI</label>
                    <InputText value={tenantName} onChange={(e) => setTenantName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleRegister()} placeholder="Şirketiniz" />
                  </div>

                  <div className="field-row">
                    <div className="field-group">
                      <label>AD SOYAD</label>
                      <InputText value={fullName} onChange={(e) => setFullName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleRegister()} placeholder="Ad Soyad" />
                    </div>
                    <div className="field-group">
                      <label>TELEFON</label>
                      <InputMask mask="0(999) 999 99 99" value={registerPhone} onChange={(e) => setRegisterPhone(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleRegister()} placeholder="0(5..)..." />
                    </div>
                  </div>

                  <div className="field-group">
                    <label>E-POSTA</label>
                    <InputText value={registerEmail} onChange={(e) => setRegisterEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleRegister()} placeholder="ornek@mail.com" />
                  </div>

                  <div className="field-group">
                    <label>ŞİFRE</label>
                    <Password value={registerPassword} onChange={(e) => setRegisterPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleRegister()} feedback={false} toggleMask pt={{root:{className:"w-full"}}} inputClassName="w-full" placeholder="••••••••" />
                  </div>

                  <Button label="Kayıt Ol" onClick={handleRegister} className="submit-btn" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Dialog
        header="Şifre Sıfırlama"
        visible={forgotVisible}
        style={{ width: "90%", maxWidth: "400px" }}
        onHide={() => setForgotVisible(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {forgotMessage && <Message severity="info" text={forgotMessage} />}

          <p style={{ fontSize: "14px", color: "var(--text-color-secondary)", margin: 0 }}>
            E-posta adresinizi girin. Hesabınız varsa şifre sıfırlama bağlantısı mail adresinize gönderilecektir.
          </p>

          <InputText
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
            placeholder="E-posta"
            disabled={forgotLoading}
            onKeyDown={(e) => e.key === "Enter" && handleForgotPassword()}
          />

          <Button
            label={forgotLoading ? "Gönderiliyor..." : "Gönder"}
            loading={forgotLoading}
            onClick={handleForgotPassword}
            style={{
              backgroundColor: "#10b981",
              border: "none",
              fontWeight: 700,
            }}
          />
        </div>
      </Dialog>

      <style>{`
        .login-page-container {
          min-height: 100vh;
          background: #0f172a;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Inter', sans-serif;
        }
        .login-card {
          width: 100%;
          max-width: 1080px;
          background: white;
          display: flex;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          overflow: hidden;
          min-height: 700px;
        }
        .brand-panel {
          width: 500px;
          background: #0f172a;
          padding: 50px;
          color: white;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex-shrink: 0;
        }
        .brand-logo-box {
          width: 44px;
          height: 44px;
          background: #10b981;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
        .brand-header {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .brand-name {
          font-size: 24px;
          font-weight: 900;
          letter-spacing: -0.5px;
          white-space: nowrap;
        }
        .brand-title {
          font-size: 32px;
          font-weight: 800;
          line-height: 1.2;
          margin: 40px 0 16px;
          word-break: break-word;
        }
        .highlight { color: #34d399; }
        .brand-subtitle {
          color: #94a3b8;
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 50px;
        }
        .feature-list {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .feature-item {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .feature-icon {
          width: 40px;
          height: 40px;
          min-width: 40px;
          flex-shrink: 0;
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.2);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #34d399;
          font-size: 18px;
        }
        .feature-text {
          display: flex;
          flex-direction: column;
        }
        .feature-title {
          font-size: 14px;
          font-weight: 700;
        }
        .feature-desc {
          font-size: 12px;
          color: #94a3b8;
        }
        .brand-footer {
          font-size: 10px;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 700;
        }

        .form-panel {
          flex: 1;
          background: #f8fafc;
          padding: 60px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          padding-top: 100px;
          overflow-y: auto;
          position: relative;
        }
        .form-panel::before {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0; height: 4px;
          background: linear-gradient(90deg, #10b981, #34d399);
          opacity: 0.5;
        }
        .form-container {
          max-width: 380px;
          margin: 0 auto;
          width: 100%;
        }
        .tab-switcher {
          display: flex;
          background: #f1f5f9;
          padding: 4px;
          border-radius: 14px;
          margin-bottom: 40px;
        }
        .tab-switcher button {
          flex: 1;
          padding: 10px;
          border-radius: 10px;
          font-size: 11px;
          font-weight: 800;
          border: none;
          background: transparent;
          color: #64748b;
          cursor: pointer;
          transition: 0.2s;
        }
        .tab-switcher button.active {
          background: white;
          color: #059669;
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }
        .form-header h2 {
          font-size: 24px;
          font-weight: 900;
          color: #0f172a;
          margin-bottom: 6px;
        }
        .form-header p {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 30px;
        }
        .form-fields {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .field-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .field-group label {
          font-size: 10px;
          font-weight: 800;
          color: #94a3b8;
          letter-spacing: 0.5px;
        }
        .field-group input {
          width: 100%;
          padding: 12px 12px 12px 40px;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: 0.2s;
        }
        .field-group input:focus {
          border-color: #10b981;
          outline: none;
          box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.1);
        }
        .label-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .forgot-btn {
          background: transparent;
          border: none;
          color: #10b981;
          font-size: 10px;
          font-weight: 800;
          cursor: pointer;
        }
        .submit-btn {
          background: #10b981 !important;
          border: none !important;
          padding: 14px !important;
          border-radius: 12px !important;
          font-weight: 800 !important;
          margin-top: 10px;
          box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.2);
        }
        .field-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }

        .fade-in {
          animation: fadeIn 0.4s ease-out forwards;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Dark Mode Overrides */
        .dark .form-header h2 {
          color: #ffffff;
        }
        .dark .form-header p {
          color: #94a3b8;
        }
        .dark .field-group label {
          color: #94a3b8;
        }
        .dark .field-group input {
          background: #1e293b;
          border-color: #334155;
          color: #f1f5f9;
        }
        .dark .field-group input::placeholder {
          color: #475569;
        }
        .dark .field-group input:focus {
          border-color: #10b981;
          box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
        }
        .dark .field-group .pi {
          color: #64748b;
        }
        .dark .tab-switcher button {
          color: #94a3b8;
        }
        .dark .tab-switcher button.active {
          color: #34d399;
        }

        @media (max-width: 900px) {
          .brand-panel { display: none; }
          .login-card { max-width: 500px; min-height: auto; border-radius: 20px; }
          .form-panel { padding: 40px; }
        }
      `}</style>
    </div>
  );
}
